module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00214.9da28154.jpg";